(function () {
  const BREAKPOINT = 768;
  const ADDING_LABEL = 'Adding…';
  const FROYA_ATTR_TEMPLATE = '_froya_template';
  const FROYA_ATTR_BUNDLE_ID = '_froya_bundle_id';

  const cartAddUrl = () => {
    const routes = window.themeVariables?.routes || window.routes || {};
    const url = routes.cartAddUrl || routes.cart_add_url || '/cart/add';
    return /\.js(\?|$)/.test(String(url)) ? url : `${String(url).replace(/\/?$/, '')}.js`;
  };

  const cartUrl = () => {
    const routes = window.themeVariables?.routes || window.routes || {};
    const url = routes.cartUrl || routes.cart_url || '/cart';
    return /\.js(\?|$)/.test(String(url)) ? url : `${String(url).replace(/\/?$/, '')}.js`;
  };

  const generateBundleId = () => {
    return '_b' + Math.random().toString(36).slice(2, 9) + Date.now().toString(36).slice(-4);
  };

  const hasActiveFilters = () => {
    const search = window.location.search;
    if (search.indexOf('filter.') !== -1 || search.indexOf('filter%2E') !== -1) return true;
    return document.querySelectorAll('.s-collection-grid .active-filter__value').length > 0;
  };

  const validLines = (list) =>
    (Array.isArray(list) ? list : []).filter((item) => Number(item?.id) > 0);

  const parsePayload = (script) => {
    if (!script) return { items: [], gifts: [] };

    try {
      const parsed = JSON.parse(script.textContent);
      if (Array.isArray(parsed)) return { items: validLines(parsed), gifts: [] };
      return {
        items: validLines(parsed?.items),
        gifts: validLines(parsed?.gifts),
      };
    } catch (error) {
      return { items: [], gifts: [] };
    }
  };

  const gidToNumericId = (gid) => {
    if (!gid) return null;
    const match = String(gid).match(/ProductVariant\/(\d+)/);
    if (match) return Number(match[1]);
    const numeric = Number(String(gid).trim());
    return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
  };

  const filterOtpBundles = (bundles) => {
    const list = Array.isArray(bundles) ? bundles : [];
    return list.filter((bundle) => {
      if (!bundle || bundle.active === false) return false;
      if (bundle.promoType === 'quantity_tier') return false;
      if (bundle.promoType === 'subscription_bundle') return false;
      if (!Array.isArray(bundle.items) || !bundle.items.length) return false;
      if (!bundle.discount || Number(bundle.discount.value) <= 0) return false;
      return true;
    });
  };

  const parseFroyaBundles = (root) => {
    const script = root?.querySelector('script[data-froya-bundle-config]');
    if (!script?.textContent?.trim()) return [];

    try {
      const parsed = JSON.parse(script.textContent);
      return filterOtpBundles(parsed?.bundles);
    } catch (_) {
      return [];
    }
  };

  const promoAppliesOnCollections = (bundle) => {
    if (!bundle || bundle.active === false) return false;
    if (bundle.promoType === 'quantity_tier') return false;
    if (bundle.promoType === 'subscription_bundle') return false;
    if (bundle.applyOnCollections === true) return true;

    const template = String(bundle.template || '').trim();
    if (!template) return true;
    return template === 'collection' || template.startsWith('collection.');
  };

  const variantMapFromItems = (items) => {
    const map = new Map();
    (items || []).forEach((item) => {
      const id = Number(item?.id);
      const quantity = Number(item?.quantity || 1);
      if (!Number.isFinite(id) || id <= 0) return;
      map.set(id, (map.get(id) || 0) + (Number.isFinite(quantity) && quantity > 0 ? quantity : 1));
    });
    return map;
  };

  const bundleMatchesVariantMap = (bundle, variantMap) => {
    for (const item of bundle.items || []) {
      const numericId = gidToNumericId(item.variantId);
      const requiredQty = Number(item.quantity) || 1;
      if (!numericId || (variantMap.get(numericId) || 0) < requiredQty) {
        return false;
      }
    }
    return true;
  };

  const sortBundles = (bundles) => {
    return [...bundles].sort((left, right) => {
      const leftQty = (left.items || []).reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
      const rightQty = (right.items || []).reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
      if (rightQty !== leftQty) return rightQty - leftQty;
      return (right.items || []).length - (left.items || []).length;
    });
  };

  const findMatchingOtp = (bundles, variantMap) => {
    const eligible = sortBundles(bundles.filter(promoAppliesOnCollections));
    return eligible.find((bundle) => bundleMatchesVariantMap(bundle, variantMap)) || null;
  };

  const presentmentRate = () => {
    const rate = Number(window.Shopify?.currency?.rate);
    return Number.isFinite(rate) && rate > 0 ? rate : 1;
  };

  const discountedSubtotalMajor = (subtotalMajor, discount) => {
    if (subtotalMajor <= 0) return 0;

    if (discount.type === 'fixed_amount') {
      const off = (Number(discount.value) || 0) * presentmentRate();
      return Math.max(0, subtotalMajor - off);
    }

    const pct = Number(discount.value) || 0;
    if (pct <= 0) return subtotalMajor;
    return Math.max(0, subtotalMajor * (1 - pct / 100));
  };

  const applyOtpDiscount = (cents, discount) => {
    const base = Number(cents) || 0;
    if (base <= 0 || !discount) return base;
    const type = discount.type === 'fixed_amount' ? 'fixed_amount' : 'percentage';
    const value = Number(discount.value);
    if (!Number.isFinite(value) || value <= 0) return base;
    const roundedFinalMajor = Math.max(0, Math.round(discountedSubtotalMajor(base / 100, { type, value })));
    return roundedFinalMajor * 100;
  };

  const formatMoney = (cents) => {
    const rounded = Math.round(Number(cents) / 100) * 100;
    let priceAmount = rounded / 100;
    const floored = Math.floor(priceAmount);
    if (priceAmount === floored) priceAmount = floored;

    const currencySymbol = window.themeVariables?.settings?.currencySymbol || '$';
    const currencyIso = window.themeVariables?.settings?.currencyCode || 'USD';

    if (currencySymbol === currencyIso) {
      return `${priceAmount} ${currencyIso}`;
    }
    return `${currencySymbol}${priceAmount}`;
  };

  const getHome = () => document.querySelector('[data-collection-bundles-home]');

  const getGrid = () => document.querySelector('.s-collection-grid__list');

  let placing = false;
  let rescuing = false;
  let restoreInFlight = null;

  const removeOtherRows = (keep) => {
    document.querySelectorAll('collection-bundles').forEach((el) => {
      if (el !== keep) el.remove();
    });
  };

  const getCanonicalRow = () => {
    const fromHome = getHome()?.querySelector('collection-bundles');
    if (fromHome) return fromHome;
    return document.querySelector('collection-bundles');
  };

  const restoreFromSection = () => {
    if (window.Shopify?.designMode) return Promise.resolve();
    if (document.querySelector('collection-bundles')) return Promise.resolve();
    if (restoreInFlight) return restoreInFlight;

    const home = getHome();
    const sectionId = home?.dataset?.sectionId;
    if (!home || !sectionId) return Promise.resolve();

    restoreInFlight = fetch(`${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((response) => {
        if (!response.ok) return null;
        return response.text();
      })
      .then((html) => {
        if (!html || document.querySelector('collection-bundles')) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('collection-bundles');
        if (!fresh) return;
        home.appendChild(document.importNode(fresh, true));
      })
      .catch(() => null)
      .finally(() => {
        restoreInFlight = null;
      });

    return restoreInFlight;
  };

  class CollectionBundles extends HTMLElement {
    #resizeRaf = null;
    #submitting = false;
    #froyaBundles = null;

    connectedCallback() {
      this.place();
      this.#applyPromoPrices();
      this.addEventListener('click', this.#onClick);
      window.addEventListener('resize', this.#onResize);
      window.addEventListener('popstate', this.#onPopState);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
      window.removeEventListener('resize', this.#onResize);
      window.removeEventListener('popstate', this.#onPopState);
    }

    #onPopState = () => {
      this.place();
    };

    #onResize = () => {
      if (this.#resizeRaf) return;
      this.#resizeRaf = requestAnimationFrame(() => {
        this.#resizeRaf = null;
        this.place();
      });
    };

    #onClick = (event) => {
      const button = event.target.closest('[data-collection-bundle-atc]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      this.#addBundle(button);
    };

    #gridColumns(grid) {
      const columns = window.getComputedStyle(grid).gridTemplateColumns.split(/\s+/).filter(Boolean);
      return columns.length > 0 ? columns.length : window.innerWidth >= BREAKPOINT ? 3 : 2;
    }

    #park() {
      const home = getHome();
      if (home && this.parentElement !== home) home.appendChild(this);
    }

    #getFroyaBundles() {
      if (!this.#froyaBundles) this.#froyaBundles = parseFroyaBundles(this);
      return this.#froyaBundles;
    }

    #getPageTemplate() {
      return String(this.dataset.froyaTemplate || '').trim();
    }

    #matchPromo(card) {
      const payload = parsePayload(card?.querySelector('[data-collection-bundle-payload]'));
      if (!payload.items.length) return { items: [], gifts: [], promo: null };
      const promo = findMatchingOtp(this.#getFroyaBundles(), variantMapFromItems(payload.items));
      return { items: payload.items, gifts: payload.gifts, promo };
    }

    #setFinalPrice(card, cents) {
      const host = card.querySelector('[data-collection-bundle-final]');
      if (!host) return;
      const priceEl = host.querySelector('.product_price') || host;
      priceEl.textContent = formatMoney(cents);
    }

    #applyPromoPrices() {
      this.querySelectorAll('[data-collection-bundle-item]').forEach((card) => {
        const overrideShopCents = Number(card.dataset.fromPriceShopCents || 0);
        if (overrideShopCents > 0) {
          const presentmentCents = Math.max(0, Math.round((overrideShopCents / 100) * presentmentRate())) * 100;
          this.#setFinalPrice(card, presentmentCents);
          return;
        }

        const { promo } = this.#matchPromo(card);
        if (!promo?.discount) return;

        const baseCents = Number(card.dataset.priceCents) || 0;
        const discounted = applyOtpDiscount(baseCents, promo.discount);
        if (discounted >= baseCents) return;

        this.#setFinalPrice(card, discounted);
      });
    }

    place() {
      if (rescuing) return;

      placing = true;
      removeOtherRows(this);

      const grid = getGrid();
      if (!grid) {
        this.#park();
        placing = false;
        return;
      }

      if (this.dataset.showOnFiltered !== 'true' && hasActiveFilters()) {
        this.#park();
        placing = false;
        return;
      }

      const cards = grid.querySelectorAll(':scope > .s-product-card');
      if (!cards.length) {
        this.#park();
        placing = false;
        return;
      }

      const insertAfter = Math.min(this.#gridColumns(grid), cards.length);
      const anchor = cards[insertAfter - 1];
      if (!anchor || this.previousElementSibling === anchor) {
        placing = false;
        return;
      }

      anchor.insertAdjacentElement('afterend', this);
      placing = false;
    }

    async #addBundle(button) {
      if (this.#submitting || button.disabled) return;

      const card = button.closest('[data-collection-bundle-item]');
      if (!card) return;

      const { items, gifts, promo } = this.#matchPromo(card);
      if (!items.length) return;

      const bundleId = generateBundleId();
      const template = String(card.dataset.froyaTemplate || '').trim() || this.#getPageTemplate();
      const payloadItems = items.map((item) => {
        const properties = { _bundle_id: bundleId };
        if (template) properties[FROYA_ATTR_TEMPLATE] = template;
        if (promo?.id) properties[FROYA_ATTR_BUNDLE_ID] = promo.id;
        return {
          id: Number(item.id),
          quantity: Number(item.quantity || 1) || 1,
          properties,
        };
      });

      if (gifts.length) {
        const cart = await fetch(cartUrl(), { headers: { Accept: 'application/json' } })
          .then((response) => response.json())
          .catch(() => ({ items: [] }));
        const inCart = new Set(
          (cart.items || []).map((line) => Number(line.variant_id || line.id)).filter(Boolean)
        );

        gifts.forEach((gift) => {
          const giftId = Number(gift.id);
          if (!giftId || inCart.has(giftId)) return;
          payloadItems.push({
            id: giftId,
            quantity: 1,
            properties: {
              _bundle_id: bundleId,
              _nbbb_free_gift: 'true',
            },
          });
        });
      }

      const idleLabel = button.textContent;
      this.#submitting = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = button.dataset.addingLabel || ADDING_LABEL;

      try {
        const response = await fetch(cartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: payloadItems,
            sections: ['mini-cart'],
            sections_url: window.location.pathname,
          }),
        });

        const data = await response.json();
        if (!response.ok || data.status) {
          this.dispatchEvent(
            new CustomEvent('cart-notification:show', {
              bubbles: true,
              cancelable: true,
              detail: {
                status: 'error',
                error: data.description || data.message || '',
              },
            })
          );
          return;
        }

        const addedLines = Array.isArray(data.items) ? data.items : [data];
        if (window.BundleCart?.registerBundle) {
          window.BundleCart.registerBundle(bundleId, addedLines);
        }

        const firstVariant = addedLines[0];
        this.dispatchEvent(
          new CustomEvent('variant:added', {
            bubbles: true,
            detail: { variant: firstVariant },
          })
        );

        const cartResponse = await fetch(cartUrl(), {
          headers: { Accept: 'application/json' },
        });
        const cart = await cartResponse.json();
        if (data.sections) cart.sections = { ...(cart.sections || {}), ...data.sections };

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: {
              cart,
              openMiniCart: true,
            },
          })
        );
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('cart-notification:show', {
            bubbles: true,
            cancelable: true,
            detail: {
              status: 'error',
              error: error?.message || '',
            },
          })
        );
      } finally {
        this.#submitting = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = idleLabel;
      }
    }
  }

  if (!customElements.get('collection-bundles')) {
    customElements.define('collection-bundles', CollectionBundles);
  }

  const syncAll = () => {
    if (placing) return;

    const row = getCanonicalRow();
    if (row) {
      row.place();
      return;
    }

    restoreFromSection();
  };

  const observeSections = () => {
    if (!window.MutationObserver) return;

    document.querySelectorAll('.s-collection-grid').forEach((section) => {
      if (section.__collectionBundlesObserved) return;
      section.__collectionBundlesObserved = true;

      new MutationObserver(() => {
        syncAll();
      }).observe(section, { childList: true, subtree: true });
    });
  };

  const sectionIdFrom = (event) =>
    event?.detail?.sectionId || String(event?.target?.id || '').replace('shopify-section-', '');

  // The row is parked inside the product grid section, not inside its own
  // #shopify-section-* wrapper, so the theme editor cannot remove it on its own.
  const removeRowForSection = (sectionId) => {
    if (!sectionId) return false;
    const row = document.getElementById(`CollectionBundles-${sectionId}`);
    if (!row) return false;
    row.remove();
    return true;
  };

  // A different section (the product grid) is being re-rendered — move the row
  // back to its home first so it survives instead of vanishing with the grid.
  const rescueRow = (container) => {
    if (!container?.contains) return;

    const home = getHome();
    const row = document.querySelector('collection-bundles');
    if (!home || !row || home.contains(row) || !container.contains(row)) return;

    rescuing = true;
    try {
      home.appendChild(row);
    } finally {
      rescuing = false;
    }
  };

  const onSectionLoad = (event) => {
    observeSections();
    if (
      !event.target?.querySelector?.(
        '[data-collection-bundles-home], collection-bundles, .s-collection-grid__list'
      )
    ) {
      return;
    }
    syncAll();
  };

  const onSectionUnload = (event) => {
    if (removeRowForSection(sectionIdFrom(event))) return;
    rescueRow(event.target);
  };

  const init = () => {
    syncAll();
    observeSections();
  };

  if (!window.__collectionBundlesBound) {
    window.__collectionBundlesBound = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.addEventListener('popstate', syncAll);
    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
  } else {
    init();
  }
})();
